import { AgeValue, OptionKeyValue } from '@myriadgenetics/mgh-types';
import CancerDetails from '../cancer-details';
import { get } from 'lodash';

interface RetinoblastomaPathology {
  age: AgeValue | string;
  side?: OptionKeyValue[];
  multifocal?: OptionKeyValue[];
}

interface Props {
  pathology: RetinoblastomaPathology;
}

function RetinoblastomaCancerDetails({ pathology }: Props) {
  const isAgeRange = (age: AgeValue | undefined) => Array.isArray(age);
  const age = isAgeRange(get(pathology, 'age')) ? get(pathology, 'age[0].optionValue', 0) : get(pathology, 'age', 0);
  const side = get(pathology, 'side[0].optionValue', '');
  const multifocal = get(pathology, 'multifocal[0].optionValue', '');

  return (
    <CancerDetails
      testId="retinoblastoma-cancer-details"
      details={[
        { labelKey: 'review.ageOfDiagnosis', displayValue: String(age), testId: 'retinoblastoma-age' },
        ...(pathology.side !== undefined ? [{ labelKey: 'review.affectedEye', displayValue: side, testId: 'retinoblastoma-side' }] : []),
        ...(pathology.multifocal !== undefined ? [{ labelKey: 'review.multifocal', displayValue: multifocal, testId: 'retinoblastoma-multifocal' }] : []),
      ]}
    />
  );
}

export default RetinoblastomaCancerDetails;
